import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginForm from './LoginForm';
import LoginCreate from './LoginCreate';
import LoginPasswordLost from './LoginPasswordLost';
import LoginPasswordReset from './LoginPasswordReset';
import styles from './Login.module.css';
import NotFound from '../NotFound';
import { useSelector } from 'react-redux';
import Loading from '../Helper/Loading';

const Login = () => {
  //const { login } = React.useContext(UserContext);
  const { data, loading } = useSelector((state) => state.user);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //if (login === true) return <Navigate to="/conta" />;
  if (loading) return <Loading />;
  if (data) return <Navigate to="/courses" />;
  return (
    <section className={styles.login}>
      <div className={styles.forms}>
        <Routes>
          <Route path="/" element={<LoginForm />} />
          <Route path="create" element={<LoginCreate />} />
          <Route path="lost" element={<LoginPasswordLost />} />
          <Route path="reset" element={<LoginPasswordReset />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </section>
  );
};

export default Login;
